import "./RazorPay.css";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { storage, auth, db } from "./firebase";
import { useParams } from "react-router-dom";
import TaskerDetails from "./TaskerDetails";

function Razorpay() {
  const { booId } = useParams();
  const history = useHistory();

  const [amount, setamount] = useState("");
  const [customer, setCustomerData] = useState("");
  const [serviceOrder, setServiceOrder] = useState([]);
  const [getHours, setGetHours] = useState([]);
  const [getTas, setGetTas] = useState("");

  function GetUserUid() {
    const [uid, setUid] = useState(null);
    useEffect(() => {
      auth.onAuthStateChanged((user) => {
        if (user) {
          console.log("YESS", user);
          setUid(user.uid);
        }
      });
    }, []);
    return uid;
  }
  const uid = GetUserUid();

  function GetCurrentUser() {
    const [user, setUser] = useState(null);
    const [roomDetails, setRoomDetails] = useState([]);

    useEffect(() => {
      auth.onAuthStateChanged((user) => {
        if (user) {
          db.collection("customers").doc(user.uid).get();
        } else {
          setUser(null);
        }
      });
    }, []);
    return user;
  }
  const user = GetCurrentUser();
  useEffect(() => {
    if (uid) {
      db.collection("customers")
        .doc(uid)
        .onSnapshot((snapshot) => setCustomerData(snapshot.data()));
    }
  });
  useEffect(() => {
    if (uid) {
      db.collection("customers")
        .doc(uid)
        .collection("serviceOrders")
        .doc(booId)
        .onSnapshot((snapshot) => setServiceOrder(snapshot.data()));
    }
  }, [uid]);
  useEffect(() => {
    if (serviceOrder?.tasId) {
      db.collection("ServiceProviders")
        .doc(serviceOrder?.tasId)
        .collection("ServiceRequests")
        .doc(serviceOrder?.requestId)
        .onSnapshot((snapshot) => setGetHours(snapshot.data()));
    }
  }, [serviceOrder?.tasId]);
  useEffect(() => {
    if (serviceOrder?.tasId) {
      db.collection("ServiceProviders")
        .doc(serviceOrder?.tasId)
        .onSnapshot((snapshot) => setGetTas(snapshot.data()));
    }
  });
  const handleSubmit = (e) => {
    e.preventDefault();

    var options = {
      key: "rzp_test_Zw883FoFo9BblA",
      key_secret: "z7bkUbsuBOn5k8LAippFaaPA",
      amount: getHours?.totalAmount * 100,
      currency: "INR",
      name: "STARTUP_PROJECTS",
      description: "for testing purpose",
      handler: function (response) {
        alert(response.razorpay_payment_id);
        if (response) {
          if (serviceOrder?.tasId) {
            db.collection("ServiceProviders")
            .doc(serviceOrder?.tasId)
            .collection("ServiceRequests")
            .doc(serviceOrder?.requestId)
            .update({
              PaymentStatus: "Paid",
            }).then(() => {
              console.log("ADDED");
            })
          }
        }
      },
      prefill: {
        name: "Anand",
        email: "anandmon1998@gmail.com",
        contact: "7025942442",
      },
      notes: {
        address: "Razorpay Corporate office",
      },
      theme: {
        color: "#3399cc",
      },
    };
    
    var pay = new window.Razorpay(options);
    pay.open();
   
  };
  return (
    <div className="payment">
      <div className="payment__container">
        <h1>
          Confirm Invoice
          <h4 style={{ fontSize: "15px", color: "grey" }}>{getTas?.name}</h4>
          <h4 style={{ fontSize: "15px", color: "grey" }}>{getTas?.service}</h4>
        </h1>
        <div className="payment__section">
          <div className="payment__title">
            <h3>Your Tasker Rate</h3>
          </div>
          <div className="payment__items">
            <h4>₹{serviceOrder?.price}/hour</h4>
          </div>
        </div>
        {/* Payment section - delivery address */}
        <div className="payment__section">
          <div className="payment__title">
            <h3>Hours Worked</h3>
          </div>
          <div className="payment__address">
            <h4 style={{}}>{getHours?.hours} </h4>
          </div>
        </div>

        {/* Payment section - Review Items */}

        <div className="payment__section">
          <div className="payment__title">
            <h3>Tasker Total</h3>
          </div>
          <div className="payment__items">
            <h4 style={{color: 'green'}}>₹ {getHours?.totalAmount}</h4>
          </div>
        </div>

        {/* Payment section - Payment method */}
        <div className="payment__section">
          <div className="payment__title">
            <h3>Payment Method</h3>
          </div>
          <div className="payment__details">
            {/* Stripe magic will go */}

            <form>
              <div className="payment__priceContainer">
                <button onClick={handleSubmit}>
                  <span>Pay Now</span>
                </button>
              </div>

              {/* Errors */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Razorpay;
